import { Color, Flex, Space, Text } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

interface RequiredFieldLabelProps {
  children: ReactNode
}

export const RequiredFieldLabel = ({ children }: RequiredFieldLabelProps): ReactElement => (
  <Flex>
    {children}
    <Space horizontal size="s2" />
    <Text color={Color.Black} inherit>
      *
    </Text>
  </Flex>
)
